module.exports = __webpack_public_path__ + "img/torino-logo-icon.9c7fa213.png";